import React from 'react';
import { ListFieldSection, FieldSet, SectionGroup } from 'Components/Layout';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import {
  WorksheetEquipmentDropdown,
  IWithWorksheetInjectedProps,
  WorksheetBalanceFieldSet,
} from 'Components/Worksheets//Core';
import { Checkbox, Field, NumericInput } from 'Components/Core';
import { useSelector } from 'react-redux';
import { valueOrDefault } from 'Lib/Any';
import FieldLabel from 'Components/Core/FieldLabel';
import { pipe } from 'Lib/Hooks/Selectors';

let BsEnIsoLiquidLimitDeterminationSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const resultCannotBeObtained = useSelector(
    pipe(createWorksheetSelector!('NonPlastic'), valueOrDefault(false), (np) => !np)
  );

  return (
    <SectionGroup heading="Liquid Limit Determination">
      <ListFieldSection>
        <FieldSet>
          <FieldLabel className="Field-Label">Material Suitability</FieldLabel>
          <Field input={<Checkbox />} label="Result cannot be obtained" name="NonPlastic" />
        </FieldSet>
      </ListFieldSection>
      {resultCannotBeObtained && (
        <ListFieldSection>
          <WorksheetBalanceFieldSet name="Balance" />
          <Field input={<WorksheetEquipmentDropdown />} equipmentType="oven" name="Oven" />
          <Field input={<NumericInput />} name="DryingTemperature" />
          <WorksheetBalanceFieldSet name="DryMassBalance" />
        </ListFieldSection>
      )}
    </SectionGroup>
  );
};

BsEnIsoLiquidLimitDeterminationSection = withInjectedProps(BsEnIsoLiquidLimitDeterminationSection);

export { BsEnIsoLiquidLimitDeterminationSection };
export default BsEnIsoLiquidLimitDeterminationSection;
